import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/apiServices';


// Async thunks for API calls
export const fetchDeviceInspections = createAsyncThunk('deviceInspections/fetchDeviceInspections', async () => {
  const response = await apiService.get('device-inspections');
  return response.data;
});

export const fetchDeviceInspectionById = createAsyncThunk('deviceInspections/fetchDeviceInspectionById', async (id) => {
  const response = await apiService.get(`device-inspections/${id}`);
  return response.data;
});

export const createDeviceInspection = createAsyncThunk('deviceInspections/createDeviceInspection', async (inspectionData) => {
  const response = await apiService.post('device-inspections', inspectionData);
  return response.data;
});

export const updateDeviceInspection = createAsyncThunk('deviceInspections/updateDeviceInspection', async ({ id, inspectionData }) => {
  const response = await apiService.put(`device-inspections/${id}`, inspectionData);
  return response.data;
});

export const deleteDeviceInspection = createAsyncThunk('deviceInspections/deleteDeviceInspection', async (id) => {
  await apiService.delete(`device-inspections/${id}`);
  return id;
});

// Initial state
const initialState = {
  deviceInspections: [],
  loading: false,
  error: null,
};

// Device Inspection slice
const deviceInspectionSlice = createSlice({
  name: 'deviceInspections',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeviceInspections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeviceInspections.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceInspections = action.payload;
      })
      .addCase(fetchDeviceInspections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createDeviceInspection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDeviceInspection.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceInspections.push(action.payload);
      })
      .addCase(createDeviceInspection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDeviceInspection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDeviceInspection.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.deviceInspections.findIndex((inspection) => inspection._id === action.payload._id);
        if (index !== -1) {
          state.deviceInspections[index] = action.payload;
        }
      })
      .addCase(updateDeviceInspection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDeviceInspection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDeviceInspection.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceInspections = state.deviceInspections.filter((inspection) => inspection._id !== action.payload);
      })
      .addCase(deleteDeviceInspection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default deviceInspectionSlice.reducer;